module.exports = __webpack_public_path__ + "static/media/2016-image.bb57bfec.png";